<script setup lang="ts">
import { Star } from 'lucide-vue-next'

/**
 * Reviews are not built yet, so this tab says so.
 *
 * It was drawn with a fixed grey gradient and near-black text, which is a white
 * panel in dark mode — the same fault the rest of the profile was cleared of.
 * It uses the surface tokens now, so it follows the theme like everything else.
 */
</script>

<template>
  <div class="rounded-xl border border-line bg-surface-2 px-6 py-12 text-center">
    <Star class="mx-auto mb-4 size-12 fill-star text-star" />
    <h3 class="mb-2 text-2xl font-semibold text-ink">Student reviews</h3>
    <p class="text-muted">
      Reviews open once students have finished their first lessons with this tutor.
    </p>
  </div>
</template>
